import React, { useState, useEffect } from 'react';
import {
  TextField,
  InputAdornment,
  Paper,
  List,
  ListItem,
  ListItemText,
  IconButton,
  CircularProgress
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  selectedApplicationData,
  setAppId,
  setSelectedApplicationIdData
} from '../../store/ApplicationSlice';
import { fetchApplicationDataByIdAndName } from '../../api/userService';

const SearchBox = () => {
  const dispatch = useDispatch();
  const uniqueValues =
    useSelector(state => state.intakeData.uniqueValues) || [];
  const [searchInput, setSearchInput] = useState('');
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (searchInput.length > 2) {
      const filtered =
        uniqueValues['customer_name']?.filter(name =>
          name.toLowerCase().includes(searchInput.toLowerCase())
        ) || [];

      if (JSON.stringify(filtered) !== JSON.stringify(suggestions)) {
        setSuggestions(filtered);
        setShowSuggestions(true);
      }
    } else {
      if (suggestions.length > 0) {
        setSuggestions([]);
        setShowSuggestions(false);
      }
    }
  }, [searchInput, uniqueValues]);

  const handleSuggestionClick = async suggestion => {
    setSearchInput('');
    setShowSuggestions(false);
    setIsLoading(true);
    const accessToken = localStorage.getItem('access_token');
    const refreshToken = localStorage.getItem('refresh_token');
    const headers = {
      'X-Access-Token': accessToken,
      'X-Refresh-Token': refreshToken,
      Accept: 'application/json'
    };

    try {
      const url = `https://cipilot-lexai-api-318242574572.us-central1.run.app/insureai/ml/intake/applications/v2/application_filter?customer_name=${encodeURIComponent(
        suggestion
      )}&skip=0&limit=15`;
      const response = await axios.get(url, { headers });
      if (response.data && response.data.length > 0) {
        // dispatch(selectedApplicationData(response.data[0]));
        // dispatch(setAppId(response.data[0]?.application_id));
        // const responseNew = await fetchApplicationDataByIdAndName(
        //   response.data[0]?.customer_name,
        //   response.data[0]?.application_id
        // );
        // dispatch(setSelectedApplicationIdData(responseNew));
        window.location.href = `/app/intake/${response.data[0]?.application_id}`;
      }
    } catch (error) {
      console.error('Error fetching application data for suggestion:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {isLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            background: 'rgba(255,255,255,0.7)',
            zIndex: 1000
          }}
        >
          <CircularProgress size={40} style={{ color: '#ff4d00' }} />
        </div>
      )}
      <div
        style={{
          position: 'relative',
          width: '350px',
          marginLeft: 'auto'
        }}
      >
        <TextField
          fullWidth
          variant='outlined'
          placeholder='Search customer...'
          size='small'
          value={searchInput}
          onChange={e => setSearchInput(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position='start'>
                <SearchIcon />
              </InputAdornment>
            )
          }}
        />
        {showSuggestions && suggestions.length > 0 && (
          <Paper
            style={{
              position: 'absolute',
              top: '100%',
              left: 0,
              right: 0,
              zIndex: 10
            }}
          >
            <List>
              {suggestions.map((suggestion, index) => (
                <ListItem
                  button
                  key={index}
                  onClick={() => handleSuggestionClick(suggestion)}
                >
                  <ListItemText primary={suggestion} />
                </ListItem>
              ))}
            </List>
          </Paper>
        )}
      </div>
    </>
  );
};

export default SearchBox;
